import React, { useState } from 'react';
import {
  Typography,
  Card,
  Switch,
  Button,
  Modal,
  message,
  Row,
  Col,
  Select,
  Divider,
  Space,
  List
} from 'antd';
import {
  BellOutlined,
  MailOutlined,
  MobileOutlined,
  LockOutlined,
  GlobalOutlined,
  SkinOutlined,
  DeleteOutlined,
  CloudDownloadOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';

const { Title, Text } = Typography;

const PersonalSettings: React.FC = () => {
  const [notificationsEnabled, setNotificationsEnabled] = useState(true);
  const [emailEnabled, setEmailEnabled] = useState(false);
  const [smsEnabled, setSmsEnabled] = useState(true);
  const [theme, setTheme] = useState('light');
  const [language, setLanguage] = useState('zh-CN');

  const handleClearCache = () => {
    Modal.confirm({
      title: '清除缓存',
      icon: <ExclamationCircleOutlined />,
      content: '确定要清除应用缓存吗？这将清除本地存储的临时数据。',
      okText: '确定',
      cancelText: '取消',
      onOk() {
        message.success('缓存已清除');
      },
    });
  };

  const handleExportData = () => {
    message.info('数据导出功能开发中');
  };

  const handleDeleteAccount = () => {
    Modal.confirm({
      title: '删除账户',
      icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
      content: '确定要删除账户吗？此操作不可恢复，所有数据将被永久删除！',
      okText: '确定删除',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        message.success('账户删除申请已提交，请联系管理员处理');
      },
    });
  };

  return (
    <div>
      <div className="page-header">
        <Title level={2}>个人设置</Title>
      </div>

      <div className="page-content">
        <Row gutter={24}>
          <Col xs={24} lg={12}>
            {/* 通知设置 */}
            <Card title={<><BellOutlined /> 通知设置</>} style={{ marginBottom: 24 }}>
              <List>
                <List.Item
                  actions={[
                    <Switch
                      checked={notificationsEnabled}
                      onChange={setNotificationsEnabled}
                    />
                  ]}
                >
                  <List.Item.Meta
                    avatar={<BellOutlined style={{ fontSize: 20, color: '#1890ff' }} />}
                    title="系统通知"
                    description="接收系统推送的通知消息"
                  />
                </List.Item>
                <List.Item
                  actions={[
                    <Switch
                      checked={emailEnabled}
                      onChange={setEmailEnabled}
                    />
                  ]}
                >
                  <List.Item.Meta
                    avatar={<MailOutlined style={{ fontSize: 20, color: '#52c41a' }} />}
                    title="邮件通知"
                    description="通过邮件接收重要通知"
                  />
                </List.Item>
                <List.Item
                  actions={[
                    <Switch
                      checked={smsEnabled}
                      onChange={setSmsEnabled}
                    />
                  ]}
                >
                  <List.Item.Meta
                    avatar={<MobileOutlined style={{ fontSize: 20, color: '#faad14' }} />}
                    title="短信通知"
                    description="通过短信接收紧急通知"
                  />
                </List.Item>
              </List>
            </Card>

            {/* 隐私设置 */}
            <Card title={<><LockOutlined /> 隐私设置</>}>
              <List>
                <List.Item
                  actions={[
                    <Button
                      type="link"
                      icon={<CloudDownloadOutlined />}
                      onClick={handleExportData}
                    >
                      导出
                    </Button>
                  ]}
                >
                  <List.Item.Meta
                    title="数据导出"
                    description="导出您的个人数据"
                  />
                </List.Item>
                <List.Item
                  actions={[
                    <Button
                      type="link"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={handleDeleteAccount}
                    >
                      申请删除
                    </Button>
                  ]}
                >
                  <List.Item.Meta
                    title="账户删除"
                    description="永久删除您的账户和所有数据"
                  />
                </List.Item>
              </List>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            {/* 界面设置 */}
            <Card title={<><SkinOutlined /> 界面设置</>} style={{ marginBottom: 24 }}>
              <List>
                <List.Item
                  actions={[
                    <Select
                      value={theme}
                      onChange={setTheme}
                      style={{ width: 120 }}
                      options={[
                        { value: 'light', label: '浅色模式' },
                        { value: 'dark', label: '深色模式' },
                        { value: 'auto', label: '跟随系统' },
                      ]}
                    />
                  ]}
                >
                  <List.Item.Meta
                    title="主题模式"
                    description="选择界面显示主题"
                  />
                </List.Item>
                <List.Item
                  actions={[
                    <Select
                      value={language}
                      onChange={setLanguage}
                      style={{ width: 120 }}
                      options={[
                        { value: 'zh-CN', label: '简体中文' },
                        { value: 'en-US', label: 'English' },
                      ]}
                    />
                  ]}
                >
                  <List.Item.Meta
                    avatar={<GlobalOutlined style={{ fontSize: 20, color: '#1890ff' }} />}
                    title="语言设置"
                    description="选择界面显示语言"
                  />
                </List.Item>
              </List>
            </Card>

            {/* 其他操作 */}
            <Card title="其他操作">
              <Space orientation="vertical" style={{ width: '100%' }}>
                <Button
                  block
                  onClick={handleClearCache}
                >
                  清除缓存
                </Button>
              </Space>

              <Divider />

              {/* 系统信息 */}
              <div style={{
                padding: 16,
                background: '#f5f5f5',
                borderRadius: 8,
                textAlign: 'center'
              }}>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  悠米宝贝宠物管理平台
                </Text>
                <br />
                <Text type="secondary" style={{ fontSize: 12 }}>
                  版本: v1.0.0
                </Text>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PersonalSettings;
